import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getInvoices({ commit }, { projectId, params = {} }) {
    return axios.get(`/projects/${projectId}/invoice-orders/search`, { params })
  },
  getInvoice({ commit }, id) {
    return axios.get(`/invoice-orders/${id}`)
  },
  updateInvoice({ commit }, data) {
    return axios.put(`/invoice-orders/${data.id}`, data)
  },
  updateInvoiceStatus({ commit }, data) {
    return axios.put(`/invoice-orders/${data.id}/change-status`, data)
  },
  downloadInvoice({ commit }, invoice) {
    return axios
      .get(`/invoice-orders/${invoice.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${invoice.document_name}.pdf`)
      })
  },
  updateItemsAdditional({ commit }, {id, data}) {
    return axios.put(`/invoice-orders/${id}/items-additional`, data)
  },
  returnInvoice({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/invoice-orders/${payload.id}/return-orders`, payload)
  },
  xeroSyncInvoice({ commit }, invoice) {
    return axios.post(`/invoice-orders/${invoice.id}/xero-sync`, {})
  },
  deleteInvoice({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/invoice-orders/${payload.id}/delete`, payload)
  },
  cancelInvoice({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/invoice-orders/${payload.id}/cancel`, payload)
  },
}
